import {customElement} from "lit/decorators/custom-element.js";
import {html, PropertyValues} from "lit";
import {AbstractViewerComponent} from "./abstract-viewer.component";
import {ArrayHelper} from "../../helpers/array.helper";
import {ClassOf} from "../../types/class-of.type";
import {Entity} from "../../domain/entities/entity";
import {container} from "tsyringe";
import {EntityManager} from "../../persistence/entity.manager";
import {EntityObjectArray} from "../../domain/entity-object-array";
import {until} from "lit/directives/until.js";

@customElement(`ha-entity-viewer`)
export class HaEntityViewerComponent extends AbstractViewerComponent<string> {

    private _entities!: Promise<EntityObjectArray<Entity>>

    protected shouldUpdate(changedProperties: PropertyValues): boolean {
        return !!this.value && super.shouldUpdate(changedProperties);
    }

    protected willUpdate(changedProperties: PropertyValues) {
        if (changedProperties.has(`value`) && !!this.value) {
            this._loadEntities().then();
        }
    }

    protected render(): unknown {
        return until(
            this._entities.then(entities => entities.length ? entities.map(entity => entity.toString()).join(", ") : html`
                <span style="font-style: italic">empty</span>`),
            html`
                <span>Loading...</span>
            `)
    }

    private async _loadEntities(): Promise<void> {
        const identifiers: string[] = (((Array.isArray(this.value))
                ? this.value
                : [this.value]
        ) ?? [])
            .filter<string>(ArrayHelper.notEmpty);

        const classOfEntity = this.propertyInfo.type() as ClassOf<Entity>;
        const repository = container.resolve(EntityManager).getRepositoryForEntity(classOfEntity)

        this._entities = repository!.findById(identifiers);
    }
}